import loadable from '@loadable/component';

export const ModalByTypeLoadable = loadable(() => import('./ModalByType'), {
  resolveComponent: (module) => module.ModalByType,
});
